import TimeInput from "@/components/Common/TimeInput/TimeInput.vue";

export default {
  components: { TimeInput },
  props: ["editedItem", "isOwnedBySubPrincipal"],
  data: () => ({
    stateItems: [
      { id: "", title: "Keine Angabe" },
      { id: "open", title: "Begehbar" },
      { id: "closed", title: "Nicht begehbar" },
      { id: "partiallyOpen", title: "Teilweise begehbar" },
      { id: "avalancheLock", title: "Lawinensperrung" },
      { id: "openingHours", title: "Gemäß Öffnungszeiten" }
    ],
    difficultyItems: [
      { id: "easy", title: "Leicht" },
      { id: "intermediate", title: "Mittel" },
      { id: "hard", title: "Schwer" }
    ],
    pathConditionItems: [
      { id: "street", title: "Teer / Straße" },
      { id: "gravel", title: "Kies / Schotter" },
      { id: "meadowPath", title: "Wiesenweg" },
      { id: "forestFloor", title: "Waldboden" },
      { id: "mountainPath", title: "Bergpfad" },
      { id: "steepTrack", title: "Steig" }
    ],
    bestSeasonItems: [
      { id: "jan", title: "Januar" },
      { id: "feb", title: "Februar" },
      { id: "mar", title: "März" },
      { id: "apr", title: "April" },
      { id: "mai", title: "Mai" },
      { id: "jun", title: "Juni" },
      { id: "jul", title: "Juli" },
      { id: "aug", title: "August" },
      { id: "sep", title: "September" },
      { id: "oct", title: "Oktober" },
      { id: "nov", title: "November" },
      { id: "dec", title: "Dezember" }
    ],
    locationItems: [
      { id: "valley", title: "Tal" },
      { id: "intermediateHeight", title: "Mittlere Höhe" },
      { id: "highAlpine", title: "Hochalpin" }
    ]
  }),
  methods: {
    preventUndefined(val) {
      return val === undefined ? "" : val;
    }
  },
  inject: ["sharedState"],
  mounted() {
    this.sharedState.stateItems = this.stateItems;
  }
};
